// src/components/sounds/TextModal.js
import { useState, useEffect } from 'react';
import api from '../../services/api';

const TextModal = ({ soundId, onClose }) => {
  const [data, setData] = useState(null);
  const [textLoading, setTextLoading] = useState(true);

  const [audioUrl, setAudioUrl] = useState('');
  const [audioLoading, setAudioLoading] = useState(true);
  const [viewMode, setViewMode] = useState('monolog'); // 'monolog' or 'dialog'

  // --- Загрузка текста ---
  useEffect(() => {
    const fetchText = async () => {
      try {
        const res = await api.get(`/sound/${soundId}/text`);
        setData(res.data);
        if (res.data.text?.dialog) {
          setViewMode('dialog');
        }
      } catch (err) {
        console.error('Ошибка загрузки текста:', err);
      } finally {
        setTextLoading(false);
      }
    };

    fetchText();
  }, [soundId]);

  // --- Автозагрузка аудио при открытии модалки ---
  useEffect(() => {
    const loadAudio = async () => {
      setAudioLoading(true);
      try {
        const res = await api.get(`/sound/audio/${soundId}`, {
          responseType: 'blob',
        });
        const url = URL.createObjectURL(res.data);
        setAudioUrl(url);
      } catch (err) {
        console.error('Ошибка загрузки аудио:', err);
        // Можно оставить audioUrl пустым — будет сообщение
      } finally {
        setAudioLoading(false);
      }
    };

    loadAudio();

    // Очистка: освобождаем URL при закрытии модалки
    return () => {
      if (audioUrl) {
        URL.revokeObjectURL(audioUrl);
      }
    };
  }, [soundId]);

  // --- Очистка при закрытии ---
  const handleClose = () => {
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
      setAudioUrl('');
    }
    onClose();
  };

  // --- Функция для разметки строк с цветами ---
  const renderText = () => {
    if (viewMode === 'dialog' && data?.text?.dialog) {
      const lines = data.text.dialog.split('\n').filter(line => line.trim() !== '');
      return lines.map((line, i) => {
        let role = null;
        let timeText = '';
        let mainText = '';

        if (line.startsWith('Речь оператора')) {
          role = 'operator';
        } else if (line.startsWith('Речь клиента')) {
          role = 'client';
        }

        if (role) {
          const parts = line.split(']: ');
          if (parts.length >= 2) {
            timeText = parts[0] + ']:';
            mainText = parts.slice(1).join(']: ');
          } else {
            timeText = line;
          }
        }

        return (
          <div key={i} className={`dialog-line ${role}`}>
            <span className="time">{timeText.split(']:')[0]}]:</span>
            <span className="text">{mainText}</span>
          </div>
        );
      });
    }

    return <pre className="text-modal-text">{data?.text?.monolog || ''}</pre>;
  };

  return (
    <div className="text-modal-overlay" onClick={handleClose}>
      <div className="text-modal" onClick={(e) => e.stopPropagation()}>
        {/* Заголовок */}
        <div className="text-modal-header">
          <h5>{data?.name_sound || 'Текст звонка'}</h5>
          <button className="text-modal-close" onClick={handleClose}>
            ×
          </button>
        </div>

        {/* Аудиоплеер — сразу виден */}
        <div className="text-modal-player px-3 pt-2 pb-3">
          {audioLoading ? (
            <div className="text-center text-muted">
              <small>Загрузка аудио...</small>
            </div>
          ) : audioUrl ? (
            <audio controls src={audioUrl} className="w-100" autoPlay={false} />
          ) : (
            <div className="text-center text-danger">
              <small>❌ Не удалось загрузить аудио</small>
            </div>
          )}
        </div>

        {/* Вкладки режимов */}
        <div className="text-modal-tabs">
          <button
            className={viewMode === 'monolog' ? 'active' : ''}
            onClick={() => setViewMode('monolog')}
          >
            По времени
          </button>
          {data?.text?.dialog && (
            <button
              className={viewMode === 'dialog' ? 'active' : ''}
              onClick={() => setViewMode('dialog')}
            >
              Диалог
            </button>
          )}
        </div>

        {/* Тело текста */}
        <div className="text-modal-body">
          {textLoading ? (
            <div className="text-center text-muted">Загрузка текста...</div>
          ) : (
            renderText()
          )}
        </div>

        {/* Футер */}
        <div className="text-modal-footer">
          <small>
            Проект: {data?.project_name} | Телефон: {data?.phone} | Длительность: {data?.time_sound}
          </small>
        </div>
      </div>
    </div>
  );
};

export default TextModal;

